import { QueryFn } from '@percent/grants-nomination-form/hooks';
import { config } from '@percent/grants-nomination-form/config/config';
import { GetOrganisationParams, GetOrganisationsResponse } from './organisations.types';

export const searchOrganisationsAction: QueryFn<[string, GetOrganisationParams], GetOrganisationsResponse> = async (
  client,
  [_, args],
) => {
  const response = await client.get(`v1/organisations`, { params: args, headers: { Authorization: config.keys.pk } });

  return response.data;
};
